<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <div class="home-wrap">
      <div class="padding-12-15 padding-b-30">
        <div class="title-text">联系我们</div>
        <div class="padding-15">
          <div class="con-wrap">
            <div class="padding-10-15 contact-header">
              <div class="contact-title padding-b-15">联系电话</div>
              <div class="padding-b-12 font-14">电话：{{serverList.server_mobile}}</div>
              <div class="padding-b-12 font-14">工作时间：09:00-18:00 周一至周五</div>
            </div>
            <div class="contact-img">
              <div>
                <img style="width: 150px" :src="serverList.wechat_code" alt="">
              </div>
              <div class="padding-t-15">微信二维码</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getServerConfig
  } from '@/api/user'
  import Nav from '@/components/h5/Nav.vue'
  export default {
    name: 'Contact',
    components: {
      Nav
    },
    data() {
      return {
        serverList: {
          wechat_code: '',
          server_mobile: ''
        },
        loading: false
      }
    },
    mounted: function() {
      var that = this
      this.loading = true
      getServerConfig().then(response => {
        that.loading = false
        that.serverList.wechat_code = response.data.wechat_code
        that.serverList.server_mobile = response.data.server_mobile;
      }).catch(error => {
        that.loading = false
        console.log(error)
        that.$toast.fail('加载客服信息失败,请稍后再试!')
      })
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap {
    font-family: Alibaba-PuHuiTi-R;

    .con-wrap {
      box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      color: #222222;
      font-size: 13px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;

      .contact-header {
        background: #FAF9F7;

        .contact-title {
          font-family: Alibaba-PuHuiTi-M;
          font-size: 16px;
        }
      }

      .contact-img {
        background: #FFFFFF;
        font-family: Alibaba-PuHuiTi-M;
        padding: 40px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/contact/Index.vue